/**
 * Taku/TopOn network_name → 中文展示名。
 * 库内仍存英文原值；筛选 value 用英文，label 用中文。
 */
const PLATFORM_MAP = {
  'tencent ads': '腾讯广告',
  tencent: '腾讯广告',
  gdt: '腾讯广告',
  'tencent ad': '腾讯广告',
  csj: '穿山甲',
  'csj (pangle)': '穿山甲',
  pangle: '穿山甲',
  'pangle (csj)': '穿山甲',
  bytedance: '穿山甲',
  穿山甲: '穿山甲',
  kuaishou: '快手',
  kuai: '快手',
  kwai: '快手',
  'kuai shou': '快手',
  baidu: '百度',
  'baidu ads': '百度',
  sigmob: 'Sigmob',
  mintegral: 'Mintegral',
  admob: 'AdMob',
  'google admob': 'AdMob',
  meta: 'Meta',
  facebook: 'Meta',
  'meta (facebook)': 'Meta',
  unity: 'Unity Ads',
  'unity ads': 'Unity Ads',
  ironsource: 'IronSource',
  'iron source': 'IronSource',
  vungle: 'Vungle',
  applovin: 'AppLovin',
  'app lovin': 'AppLovin',
  inmobi: 'InMobi',
  chartboost: 'Chartboost',
  tapjoy: 'Tapjoy',
  fyber: 'Fyber',
  bigo: 'Bigo',
  klevin: '游可赢',
  adx: 'ADX',
  'taku adx': 'ADX',
  topon: 'Taku',
  taku: 'Taku',
  anythink: 'Taku',
  nend: 'Nend',
  maio: 'Maio',
  startapp: 'StartApp',
  mytarget: 'myTarget',
  pubnative: 'PubNative',
  bidmachine: 'BidMachine',
  smaato: 'Smaato'
}

export function adPlatformLabel(name) {
  if (name == null || name === '') {
    return '-'
  }
  const raw = String(name).trim()
  if (!raw) {
    return '-'
  }
  const key = raw.toLowerCase()
  if (PLATFORM_MAP[key]) {
    return PLATFORM_MAP[key]
  }
  // 模糊：包含关键词
  if (key.includes('tencent') || key.includes('gdt')) return '腾讯广告'
  if (key.includes('csj') || key.includes('pangle') || key.includes('bytedance')) return '穿山甲'
  if (key.includes('kuaishou') || key.includes('kuai') || key.includes('kwai')) return '快手'
  if (key.includes('baidu')) return '百度'
  if (key.includes('sigmob')) return 'Sigmob'
  if (key.includes('mintegral')) return 'Mintegral'
  if (key.includes('admob')) return 'AdMob'
  if (key.includes('facebook') || key.includes('meta')) return 'Meta'
  if (key.includes('unity')) return 'Unity Ads'
  if (key.includes('iron')) return 'IronSource'
  if (key.includes('vungle')) return 'Vungle'
  if (key.includes('applovin')) return 'AppLovin'
  if (key.includes('inmobi')) return 'InMobi'
  if (key.includes('klevin')) return '游可赢'
  return raw
}
